import React from 'react';
import { ProposalsContextProvider } from '../../store/contexts/proposals';
import { Content } from './Content';
import { UserContextProvider } from '../../store/contexts/user';

export function Proposals(): JSX.Element {
  return (
    <UserContextProvider>
      <ProposalsContextProvider>
        <Content />
      </ProposalsContextProvider>
    </UserContextProvider>
  );
}
